<template>
	<div class="app-heading">
		<route-breadcrumb v-if="!print && !noBreadcrumb" :append="breadcrumbAppend" />
		<app-row class="mb-2">
			<app-cell cols="12" sm="6"><h1>
				<span>{{title}}</span>
				<span v-show="!print">
					<slot name="left"></slot>
				</span>
			</h1></app-cell>
			<app-cell cols="12" :sm="!print ? 6 : 12" v-show="!print" class="text-sm-right">
				<slot name="right"></slot>
			</app-cell>
		</app-row>
	</div>
</template>

<script>
import RouteBreadcrumb from '@/components/fragments/route/RouteBreadcrumb.vue'

export default {
	components: { RouteBreadcrumb },
	props: {
		print: {
			type: Boolean,
			default: false,
		},
		noBreadcrumb: {
			type: Boolean,
			default: false,
		},
		breadcrumbAppend: {
			type: Array,
			default: () => [],
		},
		title: String,
	},
}
</script>

<style scoped>
	.app-heading h1 {
		font-size: 20px;
		letter-spacing: 2px;
		text-transform: uppercase;
	}
</style>
